<!--
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-05-11 14:11:36
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-12-21 20:56:07
-->
<template>
    <div class="app-container">
        <!-- 查询条件 -->
        <div class="search-div common-section-bg">
            <div class="shaixuan-item">
                <el-select
                        v-model="queryParam.commId"
                        clearable
                        filterable
                        placeholder="请选择小区"
                >
                <el-option v-for="item in optionList"
                            :key="item.id"
                            :label="item.commName"
                            :value="item.id" />
                </el-select>
            </div>
            <div class="shaixuan-item">
                <el-select
                        v-model="queryParam.type"
                        clearable
                        filterable
                        placeholder="请选择租售类型"
                >
                <el-option label="出租" :value="1" />
                <el-option label="出售" :value="2" />
                <!-- <el-option label="求租" :value="3" />
                <el-option label="求购" :value="4" /> -->
                </el-select>
            </div>
            <div class="shaixuan-item">
                <el-select
                        v-model="queryParam.dyl_zushou_type"
                        clearable
                        filterable
                        placeholder="请选择资源类型"
                >
                <el-option label="住宅" :value="1" />
                <el-option label="车位" :value="2" />
                <el-option label="车库" :value="3" />
                <el-option label="储间" :value="4" />
                <el-option label="商业" :value="5" />
                <el-option label="写字楼" :value="6" />
                </el-select>
            </div>
            <div class="shaixuan-item">
                <el-select
                        v-model="queryParam.review_status"
                        clearable
                        filterable
                        placeholder="请选择审核状态"
                >
                <el-option label="待审核" :value="0" />
                <el-option label="已驳回" :value="2" />
                </el-select>
            </div>
            <!-- <div class="shaixuan-item">
                <el-input
                    v-model="queryParam.title"
                    size="mini"
                    clearable
                    placeholder="请输入关键词查找"
                />
            </div> -->
            <div class="shaixuan-item">
                <el-button
                    type="primary"
                    style="background: #1890ff; border-color: #1890ff"
                    @click="searchClick()"
                    icon="el-icon-search"
                >
                    查询
                </el-button>
                <!-- <el-button
                    @click="clickItem(0)"
                    type="primary"
                    style="background: #1890ff; border-color: #1890ff"
                    icon="el-icon-plus"
                >
                    新增
                </el-button> -->
            </div>
        </div>
        <!-- 列表展示 -->
        <div class="common-section-bg common-section-body">
            <el-table
                v-loading="listLoading"
                :data="tableData"
                size="mini"
                style="width: 100%; min-height: 300px"
            >
                <el-table-column prop="id" label="id" width="80" />
                <el-table-column label="类型" width="80">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type == 1">出租</span>
                        <span v-if="scope.row.type == 2">出售</span>
                        <span v-if="scope.row.type == 3">求租</span>
                        <span v-if="scope.row.type == 4">求购</span>
                    </template>
                </el-table-column>
                <el-table-column label="小区" minWidth="60">
                    <template slot-scope="scope">
                        <span v-if="scope.row.community">{{ scope.row.community.commName }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="资源类型" width="80">
                    <template slot-scope="scope">
                        <span v-if="scope.row.zushou_type == 1">住宅</span>
                        <span v-if="scope.row.zushou_type == 2">车位</span>
                        <span v-if="scope.row.zushou_type == 3">车库</span>
                        <span v-if="scope.row.zushou_type == 4">储间</span>
                        <span v-if="scope.row.zushou_type == 5">商业</span>
                        <span v-if="scope.row.zushou_type == 6">写字楼</span>
                    </template>
                </el-table-column>
               <el-table-column label="户型" minWidth="60">
                    <template slot-scope="scope">
                        <span v-if="scope.row.zushou_type==1">{{ scope.row.shi ? scope.row.shi + '室' : '' }}{{ scope.row.ting ? scope.row.ting + '厅' : '' }}{{ scope.row.wei ? scope.row.wei + '卫' : '' }}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="zushou_name" label="号码" minWidth="60" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.zushou_type==1">
                            -
                        </span>
                        <span v-else-if="scope.row.zushou_type==2">
                            车位号:{{ scope.row.zushou_name }}
                        </span>
                        <span v-else-if="scope.row.zushou_type==3">
                            车库号:{{ scope.row.zushou_name }}
                        </span>
                        <span v-else-if="scope.row.zushou_type==4">
                            储间号:{{ scope.row.zushou_name }}
                        </span>
                        <span v-else-if="scope.row.zushou_type>4">
                            房号:{{ scope.row.zushou_name }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="floor" label="位置" minWidth="40" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.zushou_type==5">{{ scope.row.address }}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                 <el-table-column prop="floor" label="楼层" minWidth="40" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.zushou_type==1||scope.row.zushou_type==6">{{ scope.row.floor }}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="area" label="面积" minWidth="40" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.zushou_type==1||scope.row.zushou_type==5||scope.row.zushou_type==6">{{ scope.row.area }}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="area" label="金额" minWidth="60" >
                    <template slot-scope="scope">
                        <div v-if="scope.row.type==1">
                            <span v-if="scope.row.price<=0">待定</span>
                            <span v-else-if="scope.row.zushou_type==5">{{ scope.row.price }}元/年</span>
                            <span v-else-if="scope.row.zushou_type==6">{{ scope.row.price }}元/平米每天</span>
                            <span v-else>{{ scope.row.price }}元/月</span>
                        </div>
                        <div v-else>
                            <span >{{scope.row.price}}元</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="person" label="联系人" width="100" />
                <el-table-column prop="phone" label="联系电话" minWidth="100" />
                <!-- <el-table-column prop="admin" label="状态">
                    <template slot-scope="scope">
                        <el-switch
                            v-model="scope.row.status"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            :active-value="1"
                            :inactive-value="0"
                            @change="changeStatus(scope.row)"
                        >
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="admin" label="排序" width="120">
                    <template slot-scope="scope">
                        <el-input-number
                            size="mini"
                            style="width: 100px"
                            v-model="scope.row.sort"
                            controls-position="right"
                            @change="handleChange(scope.row)"
                            :min="0"
                        ></el-input-number>
                    </template>
                </el-table-column> -->
                <el-table-column
                    fixed="right"
                    align="center"
                    label="操作"
                    width="240"
                >
                    <template slot-scope="scope">
                        <div class="btns-wrap">
                            <!-- <el-button
                                type="danger"
                                style="
                                    background: #1067e0;
                                    border-color: #1067e0;
                                "
                                @click="clickItem(1, scope.row)"
                                >修改</el-button
                            > -->
                            <el-button
                                type="danger"
                                v-if="scope.row.review_status == 0"
                                @click="review(scope.row)"
                                style="
                                    background: #fd962b;
                                    border-color: #fd962b;
                                "
                                >审核</el-button
                            >
                            <el-button
                                type="danger"
                                @click="detail(scope.row)"
                                style="
                                    background: #1890ff;
                                    border-color: #1890ff;
                                "
                                >详情</el-button
                            >
                            <!-- <el-button
                                type="danger"
                                @click="remove(scope.row)"
                                style="
                                    background: #ff4949;
                                    border-color: #ff4949;
                                "
                                >删除</el-button
                            > -->
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <pagination
                v-show="total"
                :total="total"
                :page.sync="queryParam.page"
                :limit.sync="queryParam.size"
                @pagination="getList"
            />
        </div>
        <el-drawer
            custom-class="custom-drawer"
            :visible.sync="showDrawer"
            :close-on-press-escape="false"
            :wrapper-closable="false"
            :show-close="false"
            size="660px"
        >
            <template slot="title">
                <div class="custom-title">
                    <div class="title-name">{{ isEdit ? "编辑" : "新增" }}</div>
                    <i
                        class="el-icon-circle-close close-btn pointer"
                        @click="closeDrawerFun"
                    />
                </div>
            </template>
            <div class="custom-content">
                <commonAdd
                    ref="commonAdd"
                    @onUpdateDrawer="onUpdateDrawer($event)"
                />
            </div>
        </el-drawer>
        <el-drawer
            custom-class="custom-drawer"
            :visible.sync="showReview"
            :close-on-press-escape="false"
            :wrapper-closable="false"
            :show-close="false"
            size="1000px"
        >
            <template slot="title">
                <div class="custom-title">
                    <div class="title-name">{{ typeDrawer == 3 ? "审核" : "详情" }}</div>
                    <i
                        class="el-icon-circle-close close-btn pointer"
                        @click="closeDrawerFun"
                    />
                </div>
            </template>
            <div class="custom-content">
                <reviewDetail
                    ref="reviewDetail"
                    v-if="typeDrawer == 4"
                    @onUpdateDrawer="onUpdateDrawer($event)"
                />
                <reviewStatus
                    ref="reviewStatus"
                    v-if="typeDrawer == 3"
                    @onUpdateDrawer="onUpdateDrawer($event)"
                />
            </div>
        </el-drawer>
    </div>
</template>

<script>
import fetch from "@/api/tianzheng/sell";
import Qu from "@/api/tianzheng/Qu";
import commonAdd from "./seekAdd.vue";
import reviewDetail from "./reviewDetail.vue";
import reviewStatus from "./reviewStatus.vue";
import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
export default {
    data() {
        return {
            showReview: false,
            typeDrawer:'',
            optionList: [],
            queryParam: {
                type:'',
                commId:'',
                review_status: "",
                page: 1,
                size: 10,
            },
            total: 0,
            listLoading: false,
            tableData: [],
            isEdit: 0, // 0新增 1编辑
            showDrawer: false,
        };
    },
    components: {
        Pagination,
        commonAdd,
        reviewDetail,
        reviewStatus
    },
    created() {},
    mounted() {
        this.getList();
        this.getSelectCity()
    },
    methods: {
        // 获取下拉列表
        getSelectCity () {
            Qu.select({}).then(res => {
                if (res.code == 200) {
                this.optionList = res.result;
                }
            })
        },
        // 更新弹层状态
        onUpdateDrawer(status) {
            console.log("status", status);
            if (status == 1) {
                // 成功
                this.showDrawer = false;
                this.showReview = false;
                this.getList();
            } else if (status == -1) {
                // 失败
                // this.showDrawer = false;
                // this.showReview = false;
            }
        },
        /**
         * @name: 关闭弹层
         * @return {*}
         * @desc:
         */
        closeDrawerFun() {
            this.showDrawer = false;
            this.showReview = false;
            if (this.$refs.commonAdd) {
                this.$refs.commonAdd.resetForm();
            }
        },
        /**
         * @name: 点击子项 0新增 1编辑
         * @param {*} type
         * @param {*} id
         * @return {*}
         * @desc:
         */
        clickItem(type, row) {
            let that = this;
            this.showDrawer = true;
            this.isEdit = type;
            // 给组件传值
            let obj = {
                type: type,
                id: row ? row.id : "",
            };
            this.$nextTick(function () {
                that.$refs.commonAdd.initFun(obj);
            });
        },
        /* 查询按钮，页码重置，查询数据 */
        searchClick() {
            this.queryParam.page = 1;
            this.getList();
        },
        /* 查询tableData数据 */
        getList() {
            let that = this;
            this.listLoading = true;
            fetch.reviewList(that.queryParam).then((res) => {
                that.listLoading = false;
                that.tableData = res.result.list;
                that.total = res.result.total;
            });
        },
        review(row){
            let that = this;
            this.showReview = true;
            this.typeDrawer = 3;
            // 给组件传值
            let obj = {
                id: row ? row.id : "",
            };
            this.$nextTick(function () {
                that.$refs.reviewStatus.initFun(obj);
            });
        },
        detail(row){
            let that = this;
            this.showReview = true;
            this.typeDrawer = 4;
            // 给组件传值
            let obj = {
                id: row ? row.id : "",
            };
            this.$nextTick(function () {
                that.$refs.reviewDetail.initFun(obj);
            });
        },
        remove(row) {
            let that = this;
            that.$confirm("确定删除该内容吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    // 调用接口
                    fetch.remove({ id: row.id }).then((res) => {
                        if (res.code == 200) {
                            that.$message.success(res.message);
                            that.getList();
                        } else {
                            that.$message.error(res.message);
                        }
                    });
                })
                .catch(() => {});
        },
    },
};
</script>

<style lang="scss" scoped>
.app-container {
    min-height: calc(100vh - 98px);
}
</style>
